module.exports = __webpack_public_path__ + "img/TRENTO.1a215eb6.png";